import React from 'react';

import './AdminCardImage.css';

const AdminCardImage = ({
  size = 'regular',
  shape = 'rectangle',
  img,
  noImgMsg,
  alt = '',
  noImgBox,
  imgClassName,
}) => {
  const sizeClass = `admin-card-img-${size}`;
  const shapeClass = `admin-card-img-${shape}`;

  const containerClassNames = [
    'admin-card-img-container',
    sizeClass,
    shapeClass,
  ].join(' ');

  const imgClassNames = [
    'admin-card-img',
    sizeClass,
    shapeClass,
    imgClassName,
  ].join(' ');

  const noImgClassNames = [
    'admin-card-no-picture-container',
    sizeClass,
    shapeClass,
  ].join(' ');

  return (
    <div className={containerClassNames}>
      {img ? (
        <img src={img} alt={alt} className={imgClassNames} />
      ) : (
        noImgBox || (
          <div className={noImgClassNames}>
            <label className='admin-card-no-picture-text' alt='No photo'>
              <span>{`No Photo\n ${noImgMsg || ''}`}</span>
            </label>
          </div>
        )
      )}
    </div>
  );
};

export default AdminCardImage;
